import { action, observable } from 'mobx';
import { FunctionComponent } from 'react';

export enum ConfirmModalType {
    YesCancel = 1,
    Yes = 2,
}

export interface IModalTemplate<T> {
    id: number | null;
    visible: boolean | null;
    template: FunctionComponent | null;
    modalEvent: IModalEvent | null;
    data: T | null;
}

export interface IModalEvent {
    resolve: (value?: unknown) => void;
    reject: (value?: unknown) => void;
}

export const DEFAULT_MODAL_ID = 0;

class ModalWindow<T> implements IModalTemplate<T> {
    public static ids = DEFAULT_MODAL_ID;

    @observable
    public id: number | null = null;

    @observable
    public visible: boolean | null = null;

    @observable
    public template: FunctionComponent<{}> | null = null;

    @observable
    public modalEvent: IModalEvent | null = null;

    @observable
    public data: T | null = null;

    constructor(visible: boolean, template: FunctionComponent, modalEvent: IModalEvent | null, data: T) {
        this.id = ModalWindow.ids++;

        this.visible = visible;
        this.template = template;
        this.modalEvent = modalEvent;
        this.data = data;
    }

    private get _internalCloseCall(): (value?: unknown) => void | never {
        if (this.modalEvent) {
            return this.modalEvent.resolve;
        }

        throw new Error('There is no event to close the window.');
    }

    @action
    public cancel(): void {
        this._internalCloseCall(false);
    }

    @action
    public success(): void {
        this._internalCloseCall(true);
    }
}

export default ModalWindow;
